export default __webpack_public_path__ + "static/media/Tabl_6.4fbd090a.svg";